'use client'

// Third-party Imports
import { useEffect } from 'react'

import classnames from 'classnames'

// Type Imports
import type { ChildrenType, SystemMode } from '@/core/types/types'

// Hook Imports
import { useSettings } from '@/core/hooks/useSettings'
import useLayoutInit from '@/core/hooks/useLayoutInit'

// Component Imports
import LanguageProvider from '@/core/components/LanguageProvider'

// Util Imports
import { blankLayoutClasses } from './utils/layoutClasses'
import { useAuthStore } from '../contexts/useAuthManager'

type Props = ChildrenType & {
  systemMode: SystemMode
}

const BlankLayout = (props: Props) => {
  // Props
  const { children, systemMode } = props
  const { logout } = useAuthStore()

  // Hooks
  const { settings, resetSettings } = useSettings()

  useEffect(() => {
    logout()
    resetSettings()
  }, [])

  useLayoutInit(systemMode)

  return (
    <div className={classnames(blankLayoutClasses.root, 'is-full bs-full')} data-skin={settings.skin}>
      <LanguageProvider>{children}</LanguageProvider>
    </div>
  )
}

export default BlankLayout
